import { render, staticRenderFns } from "./QuestionsTypeCard.vue?vue&type=template&id=53d5f862&"
import script from "./QuestionsTypeCard.vue?vue&type=script&lang=js&"
export * from "./QuestionsTypeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports